/**
 * Skeleton placeholder for the Diário de Obra tab on the project detail page.
 * Matches the layout of diary entry cards used in DiaryTab loading state.
 */
export default function DiaryTabSkeleton() {
  return (
    <div className="space-y-6">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="card-clean">
          <div className="animate-pulse space-y-4">
            <div className="h-6 bg-primary-100 dark:bg-primary-800 rounded w-48"></div>
            <div className="h-5 bg-primary-100 dark:bg-primary-800 rounded w-32"></div>
            <div className="h-20 bg-primary-100 dark:bg-primary-800 rounded w-full"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
